'use client';

import React from 'react';
import Link from 'next/link';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function NotFound() {
  const handleGoBack = () => {
    if (typeof window !== 'undefined') {
      window.history?.back();
    }
  };

  return (
    <div
      style={{ minHeight: '100vh', background: '#000000', color: '#ffffff', overflowX: 'hidden' }}
    >
      <Header />

      <section
        style={{
          minHeight: '70vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '80px 24px',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'radial-gradient(ellipse at center, rgba(255,26,26,0.1) 0%, transparent 70%)',
            pointerEvents: 'none',
          }}
        />
        <div style={{ position: 'relative', zIndex: 10, maxWidth: '640px' }}>
          <p
            style={{
              fontFamily: '"JetBrains Mono", monospace',
              fontSize: '0.7rem',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: '#ff1a1a',
              marginBottom: '16px',
            }}
          >
            // Error 404
          </p>

          <h1
            style={{
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 900,
              textTransform: 'uppercase',
              letterSpacing: '-0.02em',
              lineHeight: '0.9',
              fontSize: 'clamp(4rem, 18vw, 11rem)',
              color: '#ffffff',
              textShadow: '0 0 20px rgba(255,26,26,0.8), 0 0 60px rgba(255,26,26,0.4)',
              marginBottom: '8px',
            }}
          >
            404
          </h1>

          <h2
            style={{
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 900,
              textTransform: 'uppercase',
              fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
              color: '#ffffff',
              marginBottom: '16px',
            }}
          >
            Track Not Found
          </h2>

          <p
            style={{
              fontFamily: 'Manrope, sans-serif',
              color: '#cccccc',
              fontSize: '1.05rem',
              lineHeight: '1.7',
              maxWidth: '440px',
              margin: '0 auto 40px',
            }}
          >
            This page dropped out of the mix. The link may be broken or the page may have moved
            &mdash; let&apos;s get you back to the action.
          </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', justifyContent: 'center' }}>
            <Link
              href="/"
              className="btn-primary"
              style={{ fontSize: '0.9rem', padding: '14px 36px' }}
            >
              Back to Home
            </Link>
            <button
              onClick={handleGoBack}
              className="btn-outline"
              style={{ fontSize: '0.9rem', padding: '14px 36px', cursor: 'pointer' }}
            >
              Go Back
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
